/** Action type constants for the Asset Library Home Redux slice */
const ASSET_LIBRARY_HOME_TYPES = {
  SET_LOADING: 'ASSET_LIBRARY_HOME_SET_LOADING',
  SET_ERROR: 'ASSET_LIBRARY_HOME_SET_ERROR',
  FETCH_HOME_SUCCESS: 'ASSET_LIBRARY_HOME_FETCH_HOME_SUCCESS',
  CREATE_CHANNEL_SUCCESS: 'ASSET_LIBRARY_HOME_CREATE_CHANNEL_SUCCESS',
  UPDATE_CHANNEL_SUCCESS: 'ASSET_LIBRARY_HOME_UPDATE_CHANNEL_SUCCESS',
  DELETE_CHANNEL_SUCCESS: 'ASSET_LIBRARY_HOME_DELETE_CHANNEL_SUCCESS',
  ADD_QUICK_LINK_SUCCESS: 'ASSET_LIBRARY_HOME_ADD_QUICK_LINK_SUCCESS',
  UPDATE_QUICK_LINK_SUCCESS: 'ASSET_LIBRARY_HOME_UPDATE_QUICK_LINK_SUCCESS',
  DELETE_QUICK_LINK_SUCCESS: 'ASSET_LIBRARY_HOME_DELETE_QUICK_LINK_SUCCESS',
  DUPLICATE_QUICK_LINK_SUCCESS: 'ASSET_LIBRARY_HOME_DUPLICATE_QUICK_LINK_SUCCESS',
  ARCHIVE_QUICK_LINK_SUCCESS: 'ASSET_LIBRARY_HOME_ARCHIVE_QUICK_LINK_SUCCESS',
  OPEN_PANEL: 'ASSET_LIBRARY_HOME_OPEN_PANEL',
  CLOSE_PANEL: 'ASSET_LIBRARY_HOME_CLOSE_PANEL',
} as const;

export type AssetLibraryHomeTypeKey = keyof typeof ASSET_LIBRARY_HOME_TYPES;

export default ASSET_LIBRARY_HOME_TYPES;
